import { render, staticRenderFns } from "./TratamentosRestauradoresArt.vue?vue&type=template&id=09732338"
import script from "./TratamentosRestauradoresArt.vue?vue&type=script&lang=js"
export * from "./TratamentosRestauradoresArt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports